<div class="usa-modal__content">
    <div class="usa-modal__main">
        <h2 class="usa-modal__heading" id="modal-1-heading">
            {{title}}
        </h2>
        <div class="usa-prose">
          <div class="grid-row" id="modal-1-description">
            {{question}}
          </div>
          <div class="grid-row">
            <ag-grid-angular
              *ngIf="showGrid"
              style="width: 100%; height: 200px;"
              class="ag-theme-alpine"
              [gridOptions]="gridOptions"
              [rowData]="selectedNodes"
              [overlayNoRowsTemplate]="overlayNoRowsTemplate"
              [columnDefs]="columnDefs"
              [suppressDragLeaveHidesColumns]="true"
              (gridReady)="onGridReady($event)">
            </ag-grid-angular>
          </div>
          <div class="grid-row">
           <strong>Total Amount to be Paid: {{totalAmount | currency: 'USD'}}</strong>
          </div>
        </div>
        <div class="usa-modal__footer">
            <div class="grid-row" *ngIf="showGrid">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <ul class="usa-button-group">
                        <li class="usa-button-group__item">
                            <button type="button" title="{{cancelText}}" type="button" class="usa-button usa-button--outline" (click)="makeSelection(false)">{{cancelText}}</button>
                        </li>
                        <li class="usa-button-group__item">
                            <button type="button" title="{{confirmText}}" type="button" class="usa-button" (click)="onNextClick()">{{confirmText}}</button>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="grid-row" *ngIf="!showGrid">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <ul class="usa-button-group">
                        <li class="usa-button-group__item">
                            <button type="button" title="{{cancelText}}" type="button" class="usa-button usa-button--outline" (click)="makeSelection(false)">{{cancelText}}</button>
                        </li>
                        <li class="usa-button-group__item">
                            <button type="button" title="{{confirmText}}" type="button" class="usa-button" (click)="onFinalNextClick()">{{confirmText}}</button>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
    </div>
    <button class="usa-button usa-modal__close" aria-label="Close this window" data-close-modal (click)="bsModalRef.hide();makeSelection('hide')">
    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
      <use xlink:href="/assets/uswds/img/sprite.svg#close"></use>
    </svg>
  </button>
</div>

<!--<div class="modal-body">
  <div class="container-fluid">
    <div class="grid-col flex-auto">
      <legend class="usa-legend usa-legend&#45;&#45;medium">{{title}}</legend>
    </div>
  </div>
  <div class="grid-row">
    <p id="modal-1-description">{{question}}</p>
  </div>
  <div class="grid-row">
    <ag-grid-angular
      style="width: 100%; height: 300px;"
      class="ag-theme-alpine"
      [gridOptions]="gridOptions"
      [rowData]="selectedNodes"
      [overlayNoRowsTemplate]="overlayNoRowsTemplate"
      [columnDefs]="columnDefs"
      [groupIncludeTotalFooter]="true"
      [suppressDragLeaveHidesColumns]="true"
      (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="makeSelection(true)">Next</button>
  <button type="button" class="btn btn-primary" (click)="makeSelection(true)">Go back</button>
</div>-->


